const { isNullOrUndefined } = require("util");

function checkMultiple(array) {
  return array.reduce((a, b) => {
    a.errorMessage = !isNullOrUndefined(a.errorMessage)
      ? a.errorMessage
      : !isNullOrUndefined(b)
        ? b.errorMessage
        : undefined;
    return a;
  }, {});
}

function checkFirstName(value) {
  if (value.length < 2) {
    return { errorMessage: "Votre prénom est trop court" };
  }
  if (!checkAlphaNumeric(value)) {
    return {
      errorMessage: "Votre prénom ne peut comporter uniquement des lettres ou des chiffres"
    };
  }
}

function checkNameEtablissement(value) {
  if (value.length < 2) {
    return { errorMessage: "Vous devez renseigner un nom pour votre établissement" };
  }
}

function checkNameAdminDemandeContact(value) {
  if (value.length < 2) {
    return { errorMessage: "Vous devez renseigner votre nom" };
  }
}

function checkToken(value) {
  if (value.length < 2) {
    return { errorMessage: "Vous devez renseigner votre code" };
  }
}

function checkLastName(value) {
  if (value.length < 2) {
    return { errorMessage: "Votre nom est trop court" };
  }
  if (!checkAlphaNumeric(value)) {
    return { errorMessage: "Votre nom ne peut comporter uniquement des lettres ou des chiffres" };
  }
}

function checkPasswordIsHere(password) {
  if (isNullOrUndefined(password)) {
    return { errorMessage: "Veuillez renseigner votre mot de passe" };
  }
}
function checkPasswordConfirmIsHere(password, confirmPassword) {
  let booleanPassword = isNullOrUndefined(password);
  let booleanConfirmPassword = isNullOrUndefined(confirmPassword);
  if (booleanPassword) {
    return {
      errorMessage:
        "Votre nouveau mot de passe est trop court. Il doit contenir au moins 8 caractères"
    };
  }
  if (booleanConfirmPassword) {
    return {
      errorMessage: "La confirmation de votre mot de passe n'est pas identique à votre mot de passe"
    };
  }
  if (!booleanPassword && !booleanConfirmPassword) {
    return checkPassword(password, confirmPassword);
  }
}

function checkPassword(password, confirmPassword) {
  if (password.length < 8) {
    return {
      errorMessage:
        "Votre nouveau mot de passe est trop court. Il doit contenir au moins 8 caractères"
    };
  }
  if (password != confirmPassword) {
    return {
      errorMessage: "La confirmation de votre mot de passe n'est pas identique à votre mot de passe"
    };
  }
}

function checkIsTermsAccepted(value) {
  if (!value) {
    return { errorMessage: "Vous devez accepter les conditions générales" };
  }
}

function checkIsPersonalInfoAccepted(value) {
  if (!value) {
    return { errorMessage: "Vous devez accepter le traitement de vos informations personnelles" };
  }
}

function checkEmail(value) {
  var ck_regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Votre adresse email est incorrecte" };
  }
}

function checkMobilePhone(value) {
  var ck_regex = /^0[6-7]{1}(([0-9]{2}){4})$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Votre téléphone doit être écrit sous la forme 0600000000" };
  }
}

function checkPhone(value) {
  var ck_regex = /^0[1-9]{1}(([0-9]{2}){4})$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Votre téléphone doit être écrit sous la forme 0XXXXXXXXX" };
  }
}

function checkSocialSecurityNumber(value) {
  var ck_regex = /^([1-47-8])([0-9]{2})(0[0-9]|[2-35-9][0-9]|[14][0-2])((0[1-9]|[1-8][0-9]|9[0-69]|2[abAB])(00[1-9]|0[1-9][0-9]|[1-8][0-9]{2}|9[0-8][0-9]|990)|(9[78][0-9])(0[1-9]|[1-8][0-9]|90))([0-9]{3})([0-8][0-9]|9[0-7])/gi;
  if (ck_regex.test(value)) {
    /** specific checksum of first 13 digits have to be equivalent to last 2 digits **/

    /* for Corse */
    var nv = value + "";
    nv.replace("2A", 19);
    nv.replace("2B", 18);

    if (97 - (nv.substr(0, 13) % 97) == nv.substr(13, 15)) {
      return;
    }
  }

  return { errorMessage: "Veuillez saisir un numéro de sécurité sociale valide" };
}

function checkSocialSecurityNumberBirthday(socialSecurityNumber, birthday) {
  var nv = socialSecurityNumber + "";
  nv.replace("2A", 19);
  nv.replace("2B", 18);

  var birthYearSocial = nv.substr(1, 2);
  var birthMonthSocial = nv.substr(3, 2);

  var nvBirthday = new Date(birthday);

  var birthYear = nvBirthday.getYear();
  var birthMonth = nvBirthday.getMonth() + 1;

  if (!(birthYear == birthYearSocial && birthMonth == birthMonthSocial)) {
    return {
      errorMessage:
        "Veuillez saisir un numéro de sécurité sociale cohérent avec votre date de naissance."
    };
  }
}

function checkSocialSecurityNumberBirthdepartment(socialSecurityNumber, birthDepartment) {
  var nv = socialSecurityNumber + "";
  nv.replace("2A", 20);
  nv.replace("2B", 20);

  let birthDepartmentVerification = birthDepartment;
  if (birthDepartment == "2a" || birthDepartment == "2b") {
    birthDepartmentVerification = 20;
  } else if (birthDepartment.length == 1) {
    birthDepartmentVerification = "0" + birthDepartment;
  }

  var birthDepartmentSocial = nv.substr(5, 2);
  if (birthDepartmentSocial === "97") {
    birthDepartmentSocial = nv.substr(5, 3);
  }

  if (!(birthDepartmentVerification == birthDepartmentSocial)) {
    return {
      errorMessage:
        "Veuillez saisir un numéro de sécurité sociale cohérent avec votre ville et votre département de naissance."
    };
  }
}

function checkAddress(value) {
  if (!value) {
    return {
      errorMessage:
        "Votre adresse n'a pas été reconnue. Commencez à taper votre adresse et sélectionnez votre adresse dans les résultats proposés. Si votre adresse n'apparaît pas, sélectionnez une adresse à proximité de chez vous"
    };
  }
}

function checkPostalCode(value) {
  var ck_regex = /^[0-9]{5}$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Vous devez sélectionner une adresse valide" };
  }
}

function checkLatitude(value) {
  var ck_regex = /^\-?\d*\.?\d*$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Vous devez sélectionner une adresse valide" };
  }
}

function checkLongitude(value) {
  var ck_regex = /^\-?\d*\.?\d*$/;
  if (!ck_regex.test(value)) {
    return { errorMessage: "Vous devez sélectionner une adresse valide" };
  }
}

function checkBirthday(value) {
  if (!value) {
    return { errorMessage: "Vous devez renseigner votre date de naissance" };
  }
}

function checkBirthplace(value) {
  if (!value) {
    return { errorMessage: "Vous devez renseigner votre ville de naissance" };
  }
}

function checkNationality(value) {
  if (!value) {
    return { errorMessage: "Vous devez renseigner votre nationalité" };
  }
}

function checkGroupConditions(value) {
  if (value.length === 0 || value[0].group.id === -1) {
    return { errorMessage: "Veuillez sélectionner un groupe de communication" };
  }
}
function checkMessage(value) {
  if (value.length === 0) {
    return { errorMessage: "Veuillez renseigner un message à communiquer" };
  }
}

function checkAlphaNumeric(value) {
  var ck_regex = /^[A-Za-z0-9-]/;
  return ck_regex.test(value);
}

module.exports = {
  checkMultiple,
  checkFirstName,
  checkLastName,
  checkNameAdminDemandeContact,
  checkToken,
  checkNameEtablissement,
  checkPassword,
  checkPasswordConfirmIsHere,
  checkPasswordIsHere,
  checkIsTermsAccepted,
  checkIsPersonalInfoAccepted,
  checkEmail,
  checkMobilePhone,
  checkPhone,
  checkSocialSecurityNumber,
  checkAddress,
  checkPostalCode,
  checkLatitude,
  checkLongitude,
  checkBirthday,
  checkNationality,
  checkBirthplace,
  checkSocialSecurityNumberBirthday,
  checkSocialSecurityNumberBirthdepartment,
  checkGroupConditions,
  checkMessage
};



// WEBPACK FOOTER //
// ./assets/react/utils/CheckUtils.js